
import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/components/dashboard/DashboardLayout';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { PlusCircle } from 'lucide-react';
import { useProcurements } from '@/hooks/useProcurements';
import ProcurementFilters from '@/components/procurements/ProcurementFilters';
import ProcurementTable from '@/components/procurements/ProcurementTable';

const Procurements = () => {
  const navigate = useNavigate();
  const { 
    procurements, 
    loading, 
    filters, 
    updateFilters, 
    deleteProcurement 
  } = useProcurements();

  const handleFilterChange = (key: string, value: string) => {
    updateFilters({ [key]: value });
  };

  const isSearchApplied = filters.searchQuery !== "" || 
                         filters.statusFilter !== "all" || 
                         filters.typeFilter !== "all";

  return (
    <DashboardLayout>
      <div className="px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8">
          <h1 className="text-2xl font-bold text-darkgray">Upphandlingar</h1>
          <Button 
            onClick={() => navigate('/new-procurement')}
            className="mt-4 sm:mt-0 flex items-center gap-2"
          >
            <PlusCircle size={16} />
            <span>Ny upphandling</span>
          </Button>
        </div>

        <ProcurementFilters 
          statusFilter={filters.statusFilter}
          typeFilter={filters.typeFilter}
          searchQuery={filters.searchQuery}
          onFilterChange={handleFilterChange}
        />

        <Card>
          <CardContent className="pt-6">
            {loading ? (
              <div className="text-center py-10">
                <div className="animate-spin h-8 w-8 border-4 border-yellow-500 border-opacity-50 border-t-darkgray rounded-full mx-auto"></div>
                <p className="mt-4 text-gray-500">Laddar upphandlingar...</p>
              </div>
            ) : (
              <ProcurementTable 
                procurements={procurements} 
                onDelete={deleteProcurement}
                searchApplied={isSearchApplied}
              />
            )}
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default Procurements;
